import * as React from "react";
import {useState} from "react";
import {AccessLevel, Controller} from "../controller/Controller";
import {SettingsView} from "./SettingsView";
import {AuthenticationView} from "./AuthenticationView";
import {MaintenanceOnlyView} from "./MaintenanceOnlyView";

interface SettingsProps {
    controller: Controller;
    secondary: boolean;
    onExit: () => void;
}

export function Settings({controller, secondary, onExit}: SettingsProps) {
    const [accessLevel, setAccessLevel] = useState<AccessLevel>();

    if (!accessLevel) {
        return (
            <AuthenticationView
                onCancel={onExit}
                onAccess={setAccessLevel}
                controller={controller}
            />
        )
    }

    if (accessLevel === AccessLevel.MaintenanceOnly) {
        return (
            <MaintenanceOnlyView
                controller={controller}
                onClose={onExit}
            />
        )
    }

    return (
        <SettingsView
            accessLevel={accessLevel}
            controller={controller}
            secondary={secondary}
        />
    );
}

